import React from "react";

const CrossIcon = ({
  className,
  fill = "none",
  height = 30,
  width = 30,
  stroke
}: CrossIconProps) => (
  <svg width={width} height={height} viewBox="0 0 18 18" className={className}>
    <path
      fill={fill}
      stroke={stroke}
      strokeWidth={1}
      d="M9 8.64L.315 17.324a.255.255 0 01.36.36L17.685.675a.255.255 0 01-.36-.36L9 8.639.675.315a.255.255 0 01-.36.36l17.01 17.01a.255.255 0 01.36-.36L9 8.639z"
    />
  </svg>
);

export default CrossIcon;

type CrossIconProps = {
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};
